import { pagesA } from "@/data/pagesA";
import { pagesB } from "@/data/pagesB";
import { pagesC } from "@/data/pagesC";

export const SEO_PAGES = [...pagesA, ...pagesB, ...pagesC];

export const SEO_PAGE_MAP = SEO_PAGES.reduce((acc, p) => {
  acc[p.slug] = p;
  return acc;
}, {});

export const STATIC_ROUTES = [
  "/",
  "/leistungen",
  "/einsatzgebiet",
  "/ueber-uns",
  "/faq",
  "/kontakt",
  "/impressum",
  "/datenschutz",
  "/cookie-einstellungen",
];
